// frontend/src/components/Profile/AllProjectsModal.js
import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, IconButton,
  Box, Typography, alpha, useTheme
} from '@mui/material';
import {
  Close as CloseIcon,
  Folder as FolderIcon
} from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import ProfileProjectCard from './ProfileProjectCard';
import { useNavigate } from 'react-router-dom';

const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    borderRadius: theme.spacing(3),
    maxWidth: '90vw',
    width: 'auto',
    minWidth: 400,
    maxHeight: '90vh',
    backgroundColor: theme.palette.background.paper
  }
}));

const StyledDialogTitle = styled(DialogTitle)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
  padding: theme.spacing(3),
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center'
}));

const ProjectsGrid = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing(2.5),
  padding: theme.spacing(3),
  justifyContent: 'flex-start',
}));

const EmptyState = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: 400,
  width: '100%'
});

const AllProjectsModal = ({ open, onClose, projects = [] }) => {
  const theme = useTheme();
  const navigate = useNavigate();

  const handleProjectClick = (project) => {
    navigate(`/projects/${project.id}`);
    onClose();
  };

  return (
    <StyledDialog open={open} onClose={onClose} maxWidth={false} fullWidth={false}>
      <StyledDialogTitle>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <FolderIcon sx={{ fontSize: 28 }} />
          <Typography variant="h6" component="div" fontWeight="700">
            Проекты
          </Typography>
          <Typography variant="body2" component="span" sx={{ color: 'white', opacity: 0.8 }}>
            ({projects.length})
          </Typography>
        </Box>
        <IconButton onClick={onClose} sx={{ color: 'white' }}>
          <CloseIcon />
        </IconButton>
      </StyledDialogTitle>

      <DialogContent>
        {projects.length === 0 ? (
          <EmptyState>
            <FolderIcon sx={{ fontSize: 64, color: theme.palette.text.disabled, mb: 2, opacity: 0.5 }} />
            <Typography variant="h6" color="text.secondary" gutterBottom>
              Нет проектов
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Пользователь пока не участвует ни в одном проекте
            </Typography>
          </EmptyState>
        ) : (
          <ProjectsGrid>
            {projects.map((project) => (
              <Box key={project.id} sx={{
                width: { xs: '100%', sm: 'calc(50% - 10px)', md: 'calc(33.333% - 17px)' },
                minWidth: { xs: 'auto', sm: '280px', md: '280px' },
                maxWidth: { xs: '100%', sm: '310px', md: '310px' },
                display: 'flex'
              }}>
                <ProfileProjectCard
                  project={project}
                  onClick={() => handleProjectClick(project)}
                />
              </Box>
            ))}
          </ProjectsGrid>
        )}
      </DialogContent>
    </StyledDialog>
  );
};

export default AllProjectsModal;